<script>
    import {HorizontalBar} from 'vue-chartjs';

    export default {
        extends: HorizontalBar,

        props: ['rawData', 'media', 'chartId'], 

        data() {
            return {
                data: null,
                settings: {
                    youtube: {
                        counter: 'views',
                        color: '#d93826',
                        textColor: '#000',
                        hovergradient: '#a6a9ba',
                    },
                    warm_music: {
                        counter: 'plays',
                        color: '#424a60',
                        textColor: '#FFF',
                        hovergradient: '#a6a9ba',
                    },

                    shazam: {
                        counter: 'plays',
                        color: '#0088ff',
                        textColor: '#000',
                        hovergradient: '#a6a9ba',
                    },

                    soundcloud: {
                        counter: 'plays',
                        color: '#e68619',
                        textColor: '#000',
                        hovergradient: '#a6a9ba',
                    },

                    spotify_plays: {
                        counter: 'plays',
                        color: '#57bb63',
                        textColor: '#000',
                        hovergradient: '#a6a9ba',
                    },                    
                    apple_music: {
                        counter: 'plays',
                        color: '#1ac7fc',
                        textColor: '#000',
                        hovergradient: '#a6a9ba',
                    }                    
                }            
            }
        },

        mounted () {
            // this.storeData();
        },

        methods: {
            storeData() {
                if (!document.getElementById(`${this.media}-canvas-2`)) return;
                var ctx = document.getElementById(`${this.media}-canvas-2`).getContext('2d');

                var labels = this.rawData.labels;
                var datasets = this.rawData.datasets;

                this.data = {
                    highlightEnabled: false, 
                    labels: labels,
                    datasets: [{
                        label: 'Plays',
                        backgroundColor: datasets[0]*1 < datasets[1]*1 ? ( ['#555'].concat(Array(datasets.length-1).fill(this.settings[this.media].color)) ) : Array(datasets.length).fill(this.settings[this.media].color),
                        // hoverBackgroundColor: this.settings[this.media].hovergradient,
                        borderWidth: 0,
                        borderColor: this.settings[this.media].hovergradient,

                        data: datasets,
                        spanGaps: true,
                    }],
                }

                if ( this.rawData.datasets.length ){
                    $("#"+ this.chartId).parent().css("display", "block");
                    $("#"+ this.chartId).parent().css("height", this.rawData.datasets.length * 45 + 40);
                }else{
                    $("#"+ this.chartId).parent().css("display", "none");
                }

                this.renderChart(this.data, this.options);
            },

            getEvent(date){
                var filtered = $.grep(this.events, (e) => { return e.date == date; });
                return filtered.length ? filtered[0] : false;
            },
        },

        computed: {
            options() {
                return {
                    responsive: true,
                    maintainAspectRatio: false,
                    events: ['click'],

                    legend: {
                        display: false,
                    },
                    scales: {
                        xAxes: [{
                            ticks: {
                                beginAtZero: true,
                                padding: 20,
                            },

                            gridLines: {
                                drawBorder: true,
                            }
                        }],
                        yAxes: [{
                            ticks: {
                                mirror: true,
                                fontColor: "rgba(255,255,255, 1)",
                                fontSize: 12,
                            },

                            gridLines: {
                                drawBorder: false,
                                display: false, // hides the grid lines from this axis
                                offsetGridLines: false,
                            }
                        }],
                    },

                    tooltips: {
                        enabled: false,
                    },

                    animation: {
                        duration: 0,
                        onComplete () {
                            const chartInstance = this.chart;
                            const ctx = chartInstance.ctx;
                            const meta = chartInstance.controller.getDatasetMeta(0);

                            Chart.helpers.each(meta.data.forEach((bar, index) => {
                                var dataset = this.data.datasets[0].data;
                                var value = parseInt(dataset[index]);
                                var formatted = value.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");

                                // if (value > 1000000) formatted = (value / 1000000).toFixed(1) +'M';
                                // if (value > 1000) formatted = (value / 1000).toFixed(0) +'K';

                                var txt = value ? (this.data.labels[index] +" - "+ formatted +' PLAYS').toUpperCase() : this.data.labels[index] + ' - ' + 'NO DATA';

                                ctx.font = "11px Source Sans Pro";
                                ctx.textBaseline = 'middle';
                                ctx.textAlign = 'left';

                                ctx.fillStyle = '#1f2136';
                                ctx.fillRect(0, bar._model.y - 10, ctx.measureText(txt).width + 12, 20);

                                ctx.fillStyle = '#fff';
                                ctx.fillText(txt, 6, bar._model.y);
                            }));
                        },
                    },

                    onClick: (evt, item) => {
                        if (item[0] && item[0]._model && item[0]._model.label){
                            this.$root.$emit('country-click', item[0]._model.label);
                        }
                    }
                };
            },
        },

        watch: {
            rawData(){
                this.storeData();
            }
        }    
    }
</script>